import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

const BASE_CLASS = 'mt-CardFinancingLendo'

const CardFinancingPartnerMotosModalContent = ({urlIframeContent}) => {
  const {i18n} = useContext(Context)
  const frameBorder = '0'
  return (
    <div className={`${BASE_CLASS}-modal`}>
      <iframe
        src={urlIframeContent}
        className={`${BASE_CLASS}-iframe`}
        frameBorder={frameBorder}
        title={i18n.t('FINANCE.TITLE')}
      />
    </div>
  )
}

CardFinancingPartnerMotosModalContent.displayName = 'CardFinancingPartnerMotosModalContent'
CardFinancingPartnerMotosModalContent.propTypes = {
  urlIframeContent: PropTypes.string.isRequired
}

export default React.memo(CardFinancingPartnerMotosModalContent)
